'use client'

import { Button, Dialog, Heading, Paragraph } from '@graftcode/design-system'

import { EMAIL_NOT_CONFIRMED_OVERLAY_TEST_IDS } from '@common/common-test-ids.const'
import { AUTH_LOGOUT_PATH } from '@common/core.const'

import { useInitializationContext } from '../../contexts/InitializationContext'
import { useAuthUser } from '../../hooks/useAuthUser'
import { useRefreshEmailVerification } from '../../hooks/useRefreshEmailVerification'

import styles from './EmailNotConfirmedOverlay.module.scss'

export function EmailNotConfirmedOverlay() {
  useRefreshEmailVerification()
  const { isEmailVerified } = useInitializationContext()
  const { user: auth0User } = useAuthUser()
  const isVerified = isEmailVerified || auth0User?.email_verified === true

  if (isVerified) {
    return null
  }

  const handleLogout = () => {
    window.location.href = AUTH_LOGOUT_PATH
  }

  return (
    <Dialog open showDismiss={false} data-testid={EMAIL_NOT_CONFIRMED_OVERLAY_TEST_IDS.root}>
      <div className={styles.content}>
        <Heading type="h3">Confirm your email</Heading>
        <Paragraph size="sm" className={styles.message}>
          Your email is not confirmed yet. Please verify your email to continue.
        </Paragraph>
        <Button size="l" variant="outlined" text="Logout" onClick={handleLogout} className={styles.logoutButton} />
      </div>
    </Dialog>
  )
}
